import(/* webpackMode: "eager", webpackExports: ["AfricanAdvantageSection"] */ "/codebuild/output/src3826801360/src/octocare-website/components/african-advantage-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoSection"] */ "/codebuild/output/src3826801360/src/octocare-website/components/demo-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/codebuild/output/src3826801360/src/octocare-website/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/codebuild/output/src3826801360/src/octocare-website/components/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterSection"] */ "/codebuild/output/src3826801360/src/octocare-website/components/newsletter-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProblemSolutionSection"] */ "/codebuild/output/src3826801360/src/octocare-website/components/problem-solution-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductFeaturesSection"] */ "/codebuild/output/src3826801360/src/octocare-website/components/product-features-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustedBySection"] */ "/codebuild/output/src3826801360/src/octocare-website/components/trusted-by-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src3826801360/src/octocare-website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3826801360/src/octocare-website/node_modules/next/dist/client/image-component.js");
